import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";
import theme from "../theme/theme";
import { capitalizeFirstLetter } from "../utils/strings";

interface Props {
  open: boolean;
  onClose(): void;
  title: string;
  message: string;
  onConfirm(): void;
  btn1Text: string;
  btn2Text: string;
  children?:JSX.Element
}

export default function ConfirmDialog({
  open,
  onClose,
  title,
  message,
  children,
  onConfirm,
  btn1Text,
  btn2Text,
}: Props) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogTitle textAlign={'center'} sx={{mt: 1}}>{capitalizeFirstLetter(title)}</DialogTitle>
      <DialogContent>
        <DialogContentText textAlign={'center'} color={"black"} fontSize={14}>{capitalizeFirstLetter(message)}</DialogContentText>
        {children}
      </DialogContent>
      <DialogActions sx={{pb: 3, px: 3}}>
        <Button
          sx={{
            mr: 2,
            bgcolor: "transparent",
            color: theme.colors.black,
            boxShadow: 0,
            textTransform: "capitalize",
            width: "50%",
            ":hover": {
              bgcolor: "#F4F3F7",
            },
          }}
          variant="contained"
          onClick={onClose}
        >
          {btn1Text}
        </Button>
        <Button
          variant="contained"
          sx={{
            color: theme.colors.red,
            bgcolor: "transparent",
            boxShadow: 0,
            textTransform: "capitalize",
            width: "50%",
            ":hover": {
              bgcolor: theme.colors.red,
              color: theme.colors.white,
            },
          }}
          onClick={onConfirm}
        >
          {btn2Text}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
